import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import usePortalOption from '@hooks/usePortalOption'

const PortalTools = (props: { portalId :number }) => {
  const { portalId } = props

  const portalOptionPayload = usePortalOption({ portal_id: portalId })
  const {
    callbacks: { createOrEditPortalOption },
  } = portalOptionPayload

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        // @ts-expect-error TS2322
        ghost
        icon={<FontAwesomeIcon icon={faPlus} />}
        onClick={() => createOrEditPortalOption()}
        size="medium"
      >
        Add Portal Option
      </Button>
    </Tools>
  )
}

export default PortalTools
